<div>
    <form class="configuration-form get-config-form" [formGroup]="getConfigForm" (ngSubmit)="onSubmitGetConfig()">
        <mat-form-field class="input-field">
            <mat-label>{{ 'configuration.code.label' | translate }}</mat-label>
            <input
                matInput
                required
                type="text"
                id="code"
                formControlName="code"
                class="form-control"
                [ngClass]="{ 'is-invalid': submittedGetAtLeastOnce && f1.code.errors }"
            />
            @if (submittedGetAtLeastOnce && f1.code.errors) {
                <mat-error class="invalid-feedback">
                    @if (f1.code.errors.maxlength) {
                        <span>{{ 'configuration.maxLength' | translate: {length: this.maxLength} }}</span>
                    }
                    @if (f1.code.errors.minlength) {
                        <span>{{ 'configuration.minLength' | translate: {length: this.minLength} }}</span>
                    }
                </mat-error>
            }
        </mat-form-field>
        <button mat-raised-button color="primary" class="send-button" [disabled]="waitingForResponse">
            {{ 'buttons.submit' | translate }}
        </button>
    </form>
</div>
@if (configuration) {
    <mat-card appearance="outlined" class="config-info">
        <mat-card-content>
            <mat-card-title>{{ configuration.name }}</mat-card-title>
            <p>{{ "configuration.display.id" | translate }}: {{ configuration.id }}</p>
            <p>{{ "configuration.display.code" | translate }}: {{ configuration.code }}</p>
            <p>{{ "configuration.display.email" | translate }}: {{ configuration.email }}</p>
            <p>{{ "configuration.display.isPreConfiguration" | translate }}: {{ configuration.isPreConfiguration }}</p>
        </mat-card-content>
        <mat-divider></mat-divider>
        <mat-card-content class="config-update">
            <mat-card-title>{{ 'configuration.edit' | translate }}</mat-card-title>
            <div class="config-edit-content">
                <form class="configuration-form" [formGroup]="updateConfigForm" (ngSubmit)="onSubmitUpdateConfig()">
                    <p>{{ 'configuration.nameTitle' | translate }}</p>
                    <mat-form-field class="input-field" subscriptSizing="dynamic">
                        <mat-label>{{ 'configuration.name.label' | translate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            id="name"
                            formControlName="name"
                            class="form-control"
                            value="configuration.name"
                            [ngClass]="{ 'is-invalid': submittedUpdateAtLeastOnce && f2.name.errors }"
                            (keydown.enter)="onSubmitUpdateConfig()"
                        />
                        @if (submittedUpdateAtLeastOnce && f2.name.errors) {
                            <mat-error class="invalid-feedback">
                                @if (f2.name.errors.maxlength) {
                                    <span>{{ 'configuration.maxLength' | translate: {length: this.maxLength} }}</span>
                                }
                                @if (f2.name.errors.minlength) {
                                    <span>{{ 'configuration.minLength' | translate: {length: this.minLength} }}</span>
                                }
                                @if (f2.name.errors?.html) {
                                    <span>{{ 'configuration.name.html' | translate }}</span>
                                }
                            </mat-error>
                        }
                    </mat-form-field>
                    <p>{{ 'configuration.codeTitle' | translate }}</p>
                    <mat-form-field class="input-field" subscriptSizing="dynamic">
                        <mat-label>{{ 'configuration.code.labelNew' | translate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            id="newCode"
                            formControlName="newCode"
                            class="form-control"
                            [ngClass]="{ 'is-invalid': submittedUpdateAtLeastOnce && f2.newCode.errors }"
                            (keydown.enter)="onSubmitUpdateConfig()"
                        />
                        @if (submittedUpdateAtLeastOnce && f2.newCode.errors) {
                            <mat-error class="invalid-feedback">
                                @if (f2.newCode.errors.maxlength) {
                                    <span>{{ 'configuration.maxLength' | translate: {length: this.maxLength} }}</span>
                                }
                                @if (f2.newCode.errors.minlength) {
                                    <span>{{ 'configuration.minLength' | translate: {length: this.minLength} }}</span>
                                }
                            </mat-error>
                        }
                    </mat-form-field>
                </form>
            </div>
            <div class="config-actions">
                <div>
                    <p>{{ 'configuration.preConfigTitle' | translate }}</p>
                    <app-button
                        [buttonType]="'secondary'"
                        [leftIcon]="'edit'"
                        [label]="(configuration.isPreConfiguration ? 'configuration.setNotPreConfig' : 'configuration.setPreConfig') | translate"
                        [disabled]="waitingForResponse"
                        (clickEmitter)="onSubmitUpdateConfig(true)"
                    ></app-button>
                </div>
                <div>
                    <p>{{ 'configuration.recalculatePriceTitle' | translate }}</p>
                    <app-button
                        [buttonType]="'secondary'"
                        [leftIcon]="'sync'"
                        [label]="'configuration.recalculatePrice' | translate"
                        [disabled]="waitingForResponse || !configuration.isPreConfiguration"
                        (clickEmitter)="forceConfigurationPriceRefresh()"
                    ></app-button>
                </div>
                <app-button
                    [buttonType]="'secondary'"
                    [leftIcon]="'plus'"
                    [label]="'configuration.uploadImage' | translate"
                    (click)="fileInput.click()">
                    <input #fileInput type="file" class="file-upload" hidden (change)="assetUpload($event)">
                </app-button>
                <div>
                    <p>{{ 'configuration.copyTitle' | translate }}</p>
                    @if (allChecked === true) {
                        <button (click)="setAll(false)">{{'configuration.uncheck' | translate}}</button>
                    } @else {
                        <button (click)="setAll(true)">{{'configuration.check' | translate}}</button>
                    }
                    <app-scope-selection [scopes]="availableScopes"></app-scope-selection>
                    <app-button
                        class="config-button"
                        [buttonType]="'secondary'"
                        [leftIcon]="'edit'"
                        [label]="'configuration.copyButton' | translate"
                        [disabled]="waitingForResponse"
                        (click)="copyToScopes()"
                    ></app-button>
                </div>
                <app-button
                    class="config-button"
                    [buttonType]="'secondary'"
                    [label]="'configuration.downloadButton' | translate"
                    [disabled]="payloadBusy"
                    (click)="getPayload()"
                ></app-button>
                @if (payloadBusy) {
                    <p>{{ 'configuration.downloadInProgress' | translate }}</p>
                }
            </div>
        </mat-card-content>
    </mat-card>
}

